export const ORGANIZATION = `
  "@type": "Organization",
  "name": "crowdspring",
  "url": "https://www.crowdspring.com/",
  "logo": "https://images.crowdspring.com/blog/wp-content/uploads/2019/10/27125652/cs_logo-300x59.png",
  "sameAs": [
    "https://www.facebook.com/crowdspring/",
    "https://twitter.com/crowdspring/",
    "https://www.instagram.com/crowdspringhq/",
    "https://www.youtube.com/crowdspring/",
    "https://www.pinterest.com/crowdspring/",
    "https://www.linkedin.com/company/crowdspring/"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+1.877.887.7442",
    "contactType": "customer service"
  }
`;
